import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  componentsCMS: null,
  storageParks: null,
  transportTypes: null,
  transportStatus: null,
  transportProviders: null,
  states: null,
  subStates: null,
  categories: null,
  taskStatus: null,
  taskTypes: null,
  filtersHasChanged: false,
  carList: null,
  carDetail: null,
  carAccessories: null,
  taskList: null,
  carTasks: null,
  paps: {
    items: [],
    totalItems: 0
  },
  papDetail: null,
  papsAssociatedTasksList: null,
  subMenuTabSelected: null,
  transportList: null,
  discrepanciesList: null,
  lastPap: null,
  carListFilters: {
    plate: '',
    startDate: '',
    endDate: '',
    idStoragePark: '',
    idState: '',
    idCategory: ''
  },
  taskListFilter: {
    plate: '',
    startDate: '',
    endDate: '',
    idStoragePark: '',
    idTaskStatus: '',
    idTaskTypes: '',
    idPap: ''
  },
  taskFilter: {
    idTaskTypes: '',
    idTaskStatus: '',
    startDate: '',
    endDate: ''
  },
  papsFilter: {
    idStoragePark: '',
    idState: '',
    plate: '',
    offset: 0,
    limit: 10,
    sortType: 'DESC',
    currentPage: 1
  },
  transportManagerListFilters: {
    idProvider: '',
    idType: '',
    idState: '',
    plate: ''
  },
  transportEmployeesListFilters: {
    idStoragePark: '',
    idProvider: '',
    idType: '',
    idState: '',
    plate: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
